import api from '../../services/httpService';
const base = '/api/scheduler/';
export const get = async (path, params) => (await api.get(base + path, { params })).data;
export const post = async (path, data) => (await api.post(base + path, data)).data;
export const patch = async (path, data) => (await api.patch(base + path, data)).data;
export const put = async (path, data) => (await api.put(base + path, data)).data;
export const remove = async (path, data) => (await api.delete(base + path, { data })).data;
export async function download(format, params) {
  const response = await api.get(base + 'history/export/', { params: { ...params, export_format: format }, responseType: 'blob' });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement('a'); link.href = url; link.download = `scheduler-history.${format}`;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export function errorText(error) {
  const data = error?.response?.data;
  if (error?.response?.status >= 500 || typeof data === 'string') return 'Scheduler could not complete this request. Please retry. If it continues, contact your administrator.';
  const flatten = value => typeof value === 'string' ? [value] : Array.isArray(value) ? value.flatMap(flatten) : value && typeof value === 'object' ? Object.values(value).flatMap(flatten) : [];
  return flatten(data?.detail || data).slice(0, 4).join(' ') || 'Unable to complete this request. Check your connection and retry.';
}
